/**
 * Centralized API functions for Hero Section functionality
 */
import { getData, deleteData, postData, putData } from "../apiClient";

export const getHeroSections = async (
  { page = 1, limit = 10, search = "" },
  signal = null,
) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(
      `/hero-section/get/?${queryParams}`,
      {},
      {},
      signal,
    );
    console.log("result", result);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Get Hero Sections API error:", error);
    return {
      success: false,
      ...error,
    };
  }
};

// create new hero section
export const createHeroSection = async ({ data }) => {
  try {
    const result = await postData(`/hero-section/create`, data, {
      "Content-Type": "multipart/form-data",
    });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Hero Section create API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

// get hero section by id
export const getHeroSectionById = async (id) => {
  try {
    const result = await getData(`/hero-section/get/${id}`);
    console.log("result", result);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Hero Section data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const updateHeroSection = async ({ id, data }) => {
  try {
    const result = await putData(`/hero-section/update/${id}`, data, {
      "Content-Type": "multipart/form-data",
    });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Update Hero Section API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

// delete hero section by id
export const deleteHeroSection = async ({ id }) => {
  try {
    const result = await deleteData(`/hero-section/delete/${id}`);
    return {
      data: {
        message: result.message,
        success: true,
        status: result.status,
      },
    };
  } catch (error) {
    console.error("Delete Hero Section API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
        status: error.response?.status || 500,
      },
    };
  }
};
